"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_popper_1 = require("react-popper");
var SVG_SHADOW_PATH = 'M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378' +
    '-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z';
var SVG_ARROW_PATH = 'M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005' +
    'c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z';
// Arrow rotation based on the main placement location
function getArrowAngle(placement) {
    switch (placement.split('-')[0]) {
        case 'top':
            return -90;
        case 'left':
            return 180;
        case 'bottom':
            return 90;
        default:
            return 0;
    }
}
exports.getArrowAngle = getArrowAngle;
exports.PopoverArrow = function (_a) {
    var angle = _a.angle;
    return (React.createElement(react_popper_1.Arrow, { className: 'popover__arrow' },
        React.createElement("svg", { viewBox: "0 0 30 30", style: { transform: "rotate(" + angle + "deg)" } },
            React.createElement("path", { className: 'popover__arrow' + '-border', d: SVG_SHADOW_PATH }),
            React.createElement("path", { className: 'popover__arrow' + '-fill', d: SVG_ARROW_PATH }))));
};
exports.PopoverArrow.displayName = 'PopoverArrow';
//# sourceMappingURL=Arrow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Popover/Arrow.js
// module id = 266
// module chunks = 0